// only reason for this file is that jest cannot handle import.meta.url without additional babel transformation
// and it is not possible to switch to esm only because it is still experimental
// so we can mock this file easily
// @ts-ignore
export default (()=>new Worker(new URL('../token.worker.js', import.meta.url)));
